import _ from "underscore";
import TemplateView from "../../TemplateView";
import LoadingControlMixin from "../LoadingControlMixin";
import classicBridge from '../../next/ClassicBridge'

export default class DeadlineEditor extends TemplateView {
    constructor($containerEl, editable) {
        super($containerEl);

        this.state = {
            editable: editable,
        }

        this.onStatePropertyChanged('editable', editable => this.setEditable(editable))
    }
    templateHtml() {
        return "<div class='deadlineEditor atNextMount' />"
    }
    afterRender() {
        this.selector = classicBridge.integrateDeadlineSelector(this.$el[0], {
            readonly: false,
            dateClassName: 'deadlineDate',
            valueClassName: 'deadlineValue',
            crossButtonClassName: 'deadlineCrossButton',
            notDefinedClassName: 'notDefinedDeadlineDate',
            onDeadlineChanged: (date) => this.trigger('change', date),
        })
    }
    setDeadline(deadline) {
        this.selector.setProps({
            deadlineDate: deadline
        })
    }
    setEditable(editable) {
        this.selector.setProps({
            readonly: !editable
        })
    }
    setDisabled(disabled) {
        this.selector.setProps({
            readonly: disabled
        })
    }
}

_.extend(DeadlineEditor.prototype, LoadingControlMixin);


// WEBPACK FOOTER //
// ./web/js/controls/task/DeadlineEditor.js